"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StyledHeader = (0, styled_components_1.default)(base_react_components_1.Header).withConfig({ displayName: "reports-StyledHeader", componentId: "reports-1dqv8vw" }) `
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
  align-items: center;
  ${base_react_components_1.Icon} {
    color: ${base_react_components_1.theme.neutral400};
  }
`;
/** The CardHeader displays an icon and a title */
const CardHeader = (_a) => {
    var { iconName = 'buildings/business', size = 'lg', children } = _a, props = __rest(_a, ["iconName", "size", "children"]);
    return (react_1.default.createElement("div", Object.assign({ "data-testid": "header-section" }, props),
        react_1.default.createElement(StyledHeader, { size: size },
            !!iconName && react_1.default.createElement(base_react_components_1.Icon, { name: iconName }),
            children),
        react_1.default.createElement(base_react_components_1.Divider, null)));
};
exports.CardHeader = CardHeader;
exports.default = (0, styled_components_1.default)(exports.CardHeader).withConfig({ componentId: "reports-u2hycm" }) ``;
//# sourceMappingURL=index.js.map